import { runtimeEnv } from './runtime-parser';

__webpack_public_path__ = `${runtimeEnv.ASSET_URL}/assets/`;
